var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24414 2.5H6.82227C7.77995 2.5 8.69777 2.82587 9.37495 3.40612C10.0521 3.98637 10.4316 4.77356 10.4316 5.59375C10.4316 6.41394 10.0515 7.20113 9.37495 7.78138C8.69777 8.36163 7.77995 8.6875 6.82295 8.6875H4.24414L9.88164 13.5M4.24414 5.59375H11.8066M6.99414 2.5H11.8066",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.14d538edfe826b57eb6b53cd765b2c03.svg";
export { ForwardRef as ReactComponent };